import { render, staticRenderFns } from "./scrollTabsAux.vue?vue&type=template&id=42ea63b4&scoped=true&"
import script from "./scrollTabsAux.vue?vue&type=script&lang=js&"
export * from "./scrollTabsAux.vue?vue&type=script&lang=js&"
import style0 from "./scrollTabsAux.vue?vue&type=style&index=0&id=42ea63b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ea63b4",
  null
  
)

export default component.exports